import { ParkCreateDatePickerSlidein } from '../../../ui/slidein/DatePickerSlidein';
import { SingleSelectionSlideinString } from '../../../ui/slidein/SingleSelectionSlidein';
import * as PermitPurchaseState from '../../state/permit/PermitPurchaseState';
import { Duration, DurationType } from 'dg-web-shared/dto/PermitTimeUnit';
import { SlideInPortalId } from '../../../account/root/components/PortalSlidein';
import { DateTime } from 'luxon';
import {
    validityIntervalTexts,
    ValidityIntervalTexts,
} from 'dg-web-shared/common/components/translations/PermitValidityIntervalTexts.ts';

export function getDurationOptionDisplayText(
    t: number,
    timeUnit: DurationType,
    texts: ValidityIntervalTexts,
): string {
    switch (timeUnit) {
        case 'hour':
            return `${t} ${texts.Hours(t)}`;
        case 'day':
            return `${t} ${texts.Days(t)}`;
        case 'week':
            return `${t} ${texts.Weeks(t)}`;
        case 'month':
            return `${t} ${texts.Months(t)}`;
        case 'year':
            return `${t} ${texts.Years(t)}`;
        default:
            return '';
    }
}

function parseDateRange(s: string): { start: DateTime; end: DateTime } | null {
    if (!s) {
        return null;
    }
    const [from, to] = s.split('/');
    const start = DateTime.fromISO(from);
    const end = DateTime.fromISO(to ?? '');
    return start.isValid && end.isValid ? { start, end } : null;
}

export function FromDateSlidein({
    data,
    language,
    selectedDate,
    open,
    onSelect,
    onClose,
}: {
    data?: PermitPurchaseState.DateValidation.DateValidation | null;
    language: string;
    open: boolean;
    selectedDate: DateTime | null;
    onSelect: (d: DateTime) => void;
    onClose: () => void;
}) {
    if (!data) {
        return null;
    }
    const fromRange = parseDateRange(data.fromRange);
    if (!fromRange) {
        return null;
    }
    return (
        <ParkCreateDatePickerSlidein
            currentDate={DateTime.now()}
            language={language}
            onSelect={onSelect}
            onClose={onClose}
            open={open}
            selectedDate={selectedDate}
            title={validityIntervalTexts[language].FromDate()}
            minDate={fromRange.start}
            maxDate={fromRange.end}
        />
    );
}

export function DurationSlidein({
    allowedDurations,
    language,
    duration,
    durationType,
    open,
    onClose,
    onSelect,
}: {
    open: boolean;
    onClose: () => void;
    onSelect: (id: string) => void;
    allowedDurations?: Duration[];
    language: string;
    duration: number | null;
    durationType: DurationType | null;
}) {
    const texts = validityIntervalTexts[language];
    const label = validityIntervalTexts[language].Duration();

    if (!allowedDurations || allowedDurations.length === 0) {
        return null;
    }

    return (
        <SingleSelectionSlideinString
            portalId={SlideInPortalId.PARK_CREATE}
            label={label}
            options={allowedDurations.map(d => ({
                id: d.uniqueId,
                displayText: getDurationOptionDisplayText(
                    d.quantity,
                    d.type,
                    texts,
                ),
            }))}
            selection={
                duration && durationType ? `${durationType}-${duration}` : null
            }
            onSelect={onSelect}
            onClose={onClose}
            open={open}
        />
    );
}
